import { useQSet } from '@exam-management/common/qset-provider';
import { QConfigStructureCategory, QConfigStructureType } from '@exam-management/graphql';
import { Box, Grid, Text } from '@shared/components';

import { RANDOM_CONFIG_LABEL } from '../../constants';
import { formatPassingCriteria } from '../../utils';

import TimeLimitInformation from './time-limit-information';

export default function PassingCriteriaInformation() {
  const { qSet } = useQSet();
  const { qConfig } = qSet;
  const { passingCriteria, structures, timeLimit, randomType, fullScore } = qConfig;

  const filteredStructures = structures.filter(
    (structure) =>
      structure.type === QConfigStructureType.QBankStructureLevelItem &&
      structure.category === QConfigStructureCategory.Part &&
      structure.passingCriteria !== null,
  );

  return (
    <Grid
      sx={(theme) => ({
        gridTemplateColumns: '160px 1fr',
        gap: theme.spacing(4),
        '> .MuiTypography-root:nth-of-type(even)': {
          wordBreak: 'break-word',
        },
      })}
    >
      <Text variant='body1Semibold'>เกณฑ์การผ่าน</Text>
      <Text variant='body1'>
        คะแนนรวมทั้งหมด: {passingCriteria ? formatPassingCriteria(passingCriteria, fullScore) : '-'}
      </Text>

      {filteredStructures.length ? (
        <Grid
          sx={(theme) => ({
            gridTemplateColumns: 'max-content 1fr',
            gap: theme.spacing(0, 1),
            gridColumn: '2 / 3',
          })}
        >
          <Text variant='body1Semibold'>หมวดที่บังคับ:</Text>
          {filteredStructures.map((structure) => (
            <Text key={structure.id} variant='body1' sx={{ gridColumn: '2 / 3' }}>
              {`${structure.name}  ${structure.passingCriteria ? formatPassingCriteria(structure.passingCriteria, structure.score) : '-'}`}
            </Text>
          ))}
        </Grid>
      ) : null}

      <Text variant='body1Semibold'>ระยะเวลาทำข้อสอบ</Text>
      <Box>
        <TimeLimitInformation timeLimit={timeLimit} structures={structures} />
      </Box>

      <Text variant='body1Semibold'>รูปแบบการสุ่มคำถาม</Text>
      <Text variant='body1'>{randomType ? RANDOM_CONFIG_LABEL[randomType] : '-'}</Text>
    </Grid>
  );
}
